import { css } from 'emotion'
import { useConfiguracoes } from 'hooks/configuracoes'
import { useState } from 'react'

import { TextField, TextFieldProps } from '../final-form/TextField'

export const PasswordField = (props: TextFieldProps) => {
  const {
    configuracoes: { treinamento },
  } = useConfiguracoes()

  const styles = createStyles()

  const [typeTextField, setTypeTextField] = useState('password')

  const handleIconClick = () => (typeTextField === 'text' ? setTypeTextField('password') : setTypeTextField('text'))

  return (
    <TextField
      icon={typeTextField === 'text' ? 'eyeHiddenFilled' : 'eyeFilled'}
      onIconClick={handleIconClick}
      type={treinamento ? typeTextField : 'text'}
      style={!treinamento && typeTextField !== 'text' ? styles.textSecurity : undefined}
      onCopy={(e) => e.preventDefault()}
      {...props}
    />
  )
}

const createStyles = () => ({
  textSecurity: css`
    -webkit-text-security: disc;
  `,
})
